import { Subject } from 'rxjs';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type Readonly<S extends Subject<any>> = Omit<S, 'asReadonly' | 'next' | 'error' | 'complete'> & {
    asWritable: () => S;
};

declare module 'rxjs' {
    interface Subject<T> {
        asReadonly(): Readonly<Subject<T>>;
    }
    interface BehaviorSubject<T> {
        asReadonly(): Readonly<BehaviorSubject<T>>;
    }
}

Subject.prototype.asReadonly = function <S extends Subject<T>, T>(this: S): Readonly<S> {
    return Object.assign(this, {
        asWritable: () => this,
    });
};
